<template>
  <v-container>
    <div v-if="!loading">
      <v-toolbar elevation="0">
      <v-toolbar-title class="primary--text"><h2>Service Areas</h2></v-toolbar-title>
      </v-toolbar>
      <v-expansion-panels>
        <v-expansion-panel
            v-for="serviceArea in serviceData"
            :service-area="serviceArea"
            :key="serviceArea.area"
        >
          <v-expansion-panel-header>
            <v-row align="center" justify="space-between">
              <h3>{{ serviceArea.name}} - [{{ serviceArea.postalCodeStart }} - {{ serviceArea.postalCodeEnd }}]</h3>
              <v-btn
                  icon
                  v-on:click="removeServiceArea(serviceArea.id, $event)"
                  class="mr-6"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-row>

            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <ServiceAreaWasteTypes
                  :data="serviceArea.wasteTypes"
                  :get-vehicle-types="getVehicleTypes"
                  :service-area-id="serviceArea.id"
                  :remove-vehicle="removeVehicleFromWasteType"
                  :update-vehicle="updateVehicleForWasteType"
                  :remove-waste="removeWasteTypeFromServiceArea"
                  :drivers="drivers"
              />
              <AddWasteType
                  :service-area-id="serviceArea.id"
                  :get-waste-types="getWasteTypes"
                  :assigned-waste-types="serviceArea.wasteTypes ? serviceArea.wasteTypes : []" />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      <ViewServiceAreas />

      <v-dialog
          v-model="addressDialog"
          width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              class="mt-4 primary"
              v-bind="attrs"
              v-on="on"
          >
            New Service Area
          </v-btn>
        </template>
        <AddArea v-bind:location-change-callback="locationChange"/>
      </v-dialog>
    </div>
    <div v-if="loading">
    <Loading></Loading>
    </div>
  </v-container>
</template>
<script>
import ViewServiceAreas from "@/components/service-provider/admin/ViewServiceAreas";
import ServiceAreaWasteTypes from "@/components/service-provider/admin/ServiceAreaWasteTypes";
import AddWasteType from "@/components/service-provider/admin/AddWasteType";
import AddArea from "../../components/service-provider/admin/AddArea";
import Loading from "@/components/Loading";
import { doc, arrayRemove, arrayUnion, getFirestore, addDoc, collection, getDocs, updateDoc, deleteDoc, query, where }from "firebase/firestore";
const db = getFirestore();

export default {
  name: 'ServiceProviderArea',
  components: { ViewServiceAreas, ServiceAreaWasteTypes, AddWasteType, AddArea, Loading },
  data(){
    return{
      userToken: {},
      serviceData: [],
      addressDialog: false,
      wasteTypes: [],
      vehicleTypes: [],
      drivers: [],
      loading: false
    }
  },
  methods: {
    closeAddressDialog() {
      this.addressDialog = false;
    },
    locationChange(to) {
      this.closeAddressDialog();
      addDoc(collection(db, 'service-provider-areas'), to)
      .then(() => {
        // reload page..
        this.$router.go();
      })
      .catch(() => {
        alert("Error adding new service area");
      });
    },
    async getWasteTypes() {
      if (this.wasteTypes.length === 0) {
        const snapshots = await getDocs(collection(db, 'waste-types'))
            .catch((error) => {
              alert(`Could not fetch waste types: ${error.message}`);
              console.log(error);
            });
        snapshots.forEach((snapshot) => {
          this.wasteTypes.push({...snapshot.data(), id: snapshot.id});
        });
      }
      return this.wasteTypes;
    },
    async getVehicleTypes() {
      if (this.vehicleTypes.length === 0) {
        const snapshots = await getDocs(collection(db, 'vehicle-types'))
            .catch((error) => {
              alert(`Could not fetch waste types: ${error.message}`);
              console.log(error);
            });
        snapshots.forEach((snapshot) => {
          this.vehicleTypes.push({...snapshot.data(), id: snapshot.id});
        });
      }
      return this.vehicleTypes;
    },
    async removeVehicleFromWasteType(vehicleKey, wasteKey, serviceAreaId) {
      const serviceArea = this.serviceData.find((data) => { return data.id === serviceAreaId});
      const wasteType = serviceArea.wasteTypes.find((waste) => { return waste.key === wasteKey });
      const filteredVehicles = wasteType.vehicles.filter((vehicle) => { return vehicle.key !== vehicleKey});
      const updatedWasteType = { ...wasteType, vehicles: filteredVehicles }
      await updateDoc(doc(db, 'service-provider-areas', serviceAreaId), {
        wasteTypes: arrayRemove(wasteType)
      })
      .catch((error) => {
        alert(`Failed to remove vehicle from service area: ${error.message}`);
      });
      await updateDoc(doc(db, 'service-provider-areas', serviceAreaId), {
        wasteTypes: arrayUnion(updatedWasteType)
      })
      .catch((error) => {
        alert(`Failed to add updated vehicle to service area: ${error.message}`);
      });
      this.$router.go();
    },
    async updateVehicleForWasteType(vehicle, wasteKey, serviceAreaId) {
      const serviceArea = this.serviceData.find((data) => { return data.id === serviceAreaId});
      const wasteType = serviceArea.wasteTypes.find((waste) => { return waste.key === wasteKey });
      console.log(wasteType);

      await updateDoc(doc(db, 'service-provider-areas', serviceAreaId), {
        wasteTypes: arrayRemove(wasteType)
      });

      const filteredVehicles = wasteType.vehicles.filter((v) => { return v.key !== vehicle.key});
      const updatedVehicles = filteredVehicles.concat([vehicle]);
      const updatedWasteType = { ...wasteType, vehicles: updatedVehicles }
      await updateDoc(doc(db, 'service-provider-areas', serviceAreaId), {
        wasteTypes: arrayUnion(updatedWasteType)
      });
      this.$router.go();
    },
    async removeWasteTypeFromServiceArea(wasteType, serviceAreaId) {

      await updateDoc(doc(db, 'service-provider-areas', serviceAreaId), {
        wasteTypes: arrayRemove(wasteType)
      })
      .then(() => {
        this.$router.go();
      })
      .catch((error) => {
        alert(`Failed to delete waste type from service area: ${error.message}`);
      })
    },
    removeServiceArea(serviceAreaId, event) {
      if(confirm('Are you sure you want to delete this area?')){
        event.stopPropagation();
        deleteDoc(doc(db, 'service-provider-areas', serviceAreaId))
        .then(() => {
          this.$router.go();
        })
        .catch((error) => {
          alert(`Failed to remove service area: ${error.message}`);
        })
      }
    }
  },
   mounted() {
    try {
      this.loading = true;
      this.userToken = JSON.parse(sessionStorage.getItem('userToken'));
      getDocs(collection(db, 'service-provider-areas'))
      .then((snap) => {
        snap.forEach((area) => {
          this.serviceData.push({ ...area.data(), id: area.id });
          this.loading = false;
        });
      });
      if(this.drivers.length === 0) {
        const q = query(collection(db, 'users'), where('scope', '==', 'driver'));
        getDocs(q)
        .then((snapshot) => {
          snapshot.forEach((driver) => {
            this.drivers.push({...driver.data(), id: driver.id});
            this.loading = false;
          });
        });
      }
    } 
    catch (error) {
      this.loading = false;
      alert('No logged in user detected');
      console.log(error);
      this.$router.push({ path: '/login'});
    }
  }
}
</script>
<style scoped>

</style>